package com.sddamico.swigmore.ds.brand

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.SwType
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.stitch
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** Gold medallion on green (header, app icon), or green medallion on cream (sign-in card). */
enum class CrestVariant { Gold, Field }

/** The league crest. A placeholder "S" until the league has a real crest. */
@Composable
fun Crest(
  modifier: Modifier = Modifier,
  variant: CrestVariant = CrestVariant.Gold,
  size: Int = 42,
  letter: String = "S",
) {
  val (bg, fg) = when (variant) {
    CrestVariant.Gold -> SwColor.gold to SwColor.field700
    CrestVariant.Field -> SwColor.field700 to SwColor.cream
  }
  Div(
    attrs = Modifier
      .css(
        "width" to "${size}px",
        "height" to "${size}px",
        "flex" to "0 0 auto",
        "border-radius" to "50%",
        "background" to bg,
        "color" to fg,
        "display" to "flex",
        "align-items" to "center",
        "justify-content" to "center",
        "font" to "400 ${size / 2}px ${SwType.display}",
      )
      .then(if (variant == CrestVariant.Gold) Modifier.stitch(SwColor.inkFaint, "5px") else Modifier)
      .then(modifier)
      .toAttrs { attr("aria-hidden", "true") }
  ) { Text(letter) }
}
